"use client";

import { useEffect } from "react";

/**
 * Thin client wrapper that initialises Capacitor native plugins on mount
 * and hides the splash screen once the DOM has painted.
 */
export default function CapacitorInit() {
  useEffect(() => {
    import("@/lib/capacitor-init").then(({ hideSplash }) => {
      // Wait for the first paint, then hide splash
      requestAnimationFrame(() => {
        setTimeout(hideSplash, 300);
      });
    });

    // Safety timeout — force-hide splash after 10 seconds no matter what
    const safety = setTimeout(async () => {
      try {
        const { hideSplash } = await import("@/lib/capacitor-init");
        hideSplash();
      } catch {}
    }, 10000);

    return () => clearTimeout(safety);
  }, []);

  return null;
}
